// Unpublished Work © 2020-2023 Deere & Company

import {OktaAuth} from '@okta/okta-auth-js';
import {processEnvSvc} from '../services/process-env-svc';

export const transformAuthState = async (_oktaAuth, authState) => {
    if (processEnvSvc('BYPASS_OKTA')) {
        authState.accessToken = 'local';
        authState.idToken = 'local';
        authState.isAuthenticated = true;
        _oktaAuth.getAccessToken = () => authState.accessToken;
        _oktaAuth.token.getWithoutPrompt = () => [
            'local',
            'local'
        ];
        _oktaAuth.token.getUserInfo = () => new Promise((resolve) => resolve({
            userID: 'TEST'
        }));
    }

    return authState;
};

export const authConfig = {
    clientId: processEnvSvc('OKTA_CLIENT_ID'),
    issuer: processEnvSvc('OKTA_ISSUER'),
    transformAuthState,
    pkce: true,
    redirectUri: globalThis.location.origin,
    responseMode: ['fragment'],
    scopes: ['profile', 'openid', 'offline_access', 'CSCAdGroups']
};

export const oktaAuth = new OktaAuth(authConfig);

oktaAuth.start();
